var _a;
import { immerable } from 'immer';
/**
 * 選択されたコース情報
 */
var SelectedPmlCourse = /** @class */ (function () {
    function SelectedPmlCourse() {
        this[_a] = true;
    }
    Object.defineProperty(SelectedPmlCourse.prototype, "course", {
        get: function () {
            return this.selectedPmlCourse;
        },
        enumerable: false,
        configurable: true
    });
    /** 選択 */
    SelectedPmlCourse.prototype.select = function (course) {
        if (course) {
            this.selectedPmlCourse = course;
        }
    };
    /** 選択状態のクリア */
    SelectedPmlCourse.prototype.clear = function () {
        this.selectedPmlCourse = undefined;
    };
    return SelectedPmlCourse;
}());
export { SelectedPmlCourse };
_a = immerable;
/**
 * 選択されたコースのインスタンスを生成
 */
export function createSelectedPmlCourse() {
    return new SelectedPmlCourse();
}
